import {Component} from '@angular/core';

@Component({
   selector: 'app-reject-reason',
   templateUrl: './reject-reason.component.html',
   styleUrls: ['./reject-reason.component.css']
})
export class RejectReasonComponent {
   rejReason: string;

   constructor() {
      // This is intentional.
   }
}
